/**
 * Sprung nach pm.elbklar.com — in das Projekt, das aus einer Anfrage wurde.
 *
 * Eine gelungene Übergabe endete bis zum 28.10.2026 stumm: Die Karte bekam
 * eine „PM“-Marke, die nur ein `<span title>` war, die Oberfläche lud die
 * Liste neu und sagte nichts. Wer nachsehen wollte, wechselte die App und riet
 * den Projektnamen — der damals der Kundenname war, bei zwei Anfragen
 * desselben Kunden also zweimal derselbe (Ü-9, Ü-12).
 */

const PM_URL = import.meta.env.VITE_PM_URL || 'https://pm.elbklar.com';

export function projektUrl(projektId: string): string {
  return `${PM_URL}/projects/${projektId}`;
}
